import { render, staticRenderFns } from "./ReserveUpdateComponent.vue?vue&type=template&id=3bb47aed&scoped=true"
import script from "./ReserveUpdateComponent.vue?vue&type=script&lang=js"
export * from "./ReserveUpdateComponent.vue?vue&type=script&lang=js"
import style0 from "./ReserveUpdateComponent.vue?vue&type=style&index=0&id=3bb47aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb47aed",
  null
  
)

export default component.exports